import { useState } from "react";
import { styled } from "styled-components";
import { initiateArView } from "../../utils/arUtils";
import Button from "../Button";
import { ArQrModalFromConfig } from "../ArQrModal";
import Icon from "../Icon";
import { getIsArSupported } from "../../utils/arUtils";
import { useConfigAr, useConfigCloudName, useConfigModelUrl } from "../../hooks/config";
import useAnalytics from "../../hooks/useAnalytics";

const StyledButton = styled(Button)`
    font-size: 18px;
    cursor: pointer;
		
    svg {
        margin-right: 4px;
    }
`;

const ArStartButton = ({ modelUrl, fallbackUrl, params, renderingApi, cloudName }) => {
	const onClick = () => {
		initiateArView(modelUrl, fallbackUrl, params, renderingApi, cloudName);
	};

	return (
		<StyledButton onClick={onClick}>
			<Icon icon="ar"/> Open in AR
		</StyledButton>
	);
};

const ArQrButton = ({ renderingApi }) => {
	const { triggerAnalyticsEvent } = useAnalytics();
	const cloudName = useConfigCloudName();
	const modelUrl = useConfigModelUrl();
	const { fallbackUrl, ...arParams } = useConfigAr();
	const [showQrModal, setShowQrModal] = useState(false);
	const isArSupported = getIsArSupported();

	const onModalClose = () => setShowQrModal(false);

	const onClick = () => {
		if (isArSupported) {
			initiateArView(modelUrl, fallbackUrl, arParams, renderingApi, cloudName, triggerAnalyticsEvent);
		} else {
			setShowQrModal(true);
		}
	}

	return (
		<>
			<StyledButton onClick={onClick}>
				<Icon icon="ar"/> View in AR
			</StyledButton>
			{showQrModal && <ArQrModalFromConfig isOpen={showQrModal} onClose={onModalClose}/>}
		</>
	);
};

export {
	ArStartButton,
	ArQrButton,
};
